var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaskBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920.303,
    height: 159.09,
    viewBox: "0 0 1920.303 159.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_1_1",
    "data-name": "Component 1 \\u2013 1",
    transform: "translate(0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M0,817.336s322.041-83.368,575.045-85.783,473.574,86.742,776.909,76.805S1920,697.562,1920,697.562v159.09H0Z",
    transform: "translate(0 -697.562)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M0,817.336s322.041-83.368,575.045-85.783,473.574,86.742,776.909,76.805S1920,697.562,1920,697.562",
    transform: "translate(0 -677.904)",
    fill: "none",
    stroke: "#cfa70a",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskBottom);
export default __webpack_public_path__ + "static/media/mask-bottom.29fea4102d41e3557afa28a0f8adc63d.svg";
export { ForwardRef as ReactComponent };